// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__yUD57","errorMessage":"styles_errorMessage__UtgJM"};